<template>
  <div class="back_button">
    <BbBtn size="x-small" type="icon" icon="chevron-left" icon-size="small" no-background @click="goBack" />
    <TextBody i18n-key="common.back" tag="span" color="#1C1C1D" />
  </div>
</template>

<script>
import TextBody from '~/components/common/TextBody.vue';

export default {
  components: { TextBody },
  props: {
    goBack: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.back_button {
  display: flex;
  align-items: center;
  gap: $bb-spacing-2;
}
</style>
